import { doUpdateCurrentUserForOnboarding } from 'ducks/currentUser/operations'
import { V2_VERIFICATION_PAGE } from '../pages'

export function doSaveAndRedirect({ password }) {
  return dispatch => {
    return dispatch(
      doUpdateCurrentUserForOnboarding({
        password,
        passwordConfirmation: password,
      })
    ).then(() => {
      dispatch({
        type: V2_VERIFICATION_PAGE,
      })
    })
  }
}
